import { invalidate, useThree } from '@react-three/fiber';
import React, { useContext, useEffect, useRef, useState } from 'react'
import * as THREE from "three";
import { GVarState } from '../StoreState/Gstate';
import ShapBox from './ShapBox';
import gsap from "gsap";
import { defaultZoomDistance, sceneTiltDeg } from './mapConfig';
import { json } from 'react-router-dom';


function LoadMap() {
  let { controls, camera, scene } = useThree()
  let groupRef = useRef()
  let g = useContext(GVarState);

  const [texture, settexture] = useState(null)


  useEffect(() => {
    const loader = new THREE.TextureLoader();
    const textureLoad = loader.load("/icon/navigation_icon.png");
    settexture(textureLoad)
  }, [])


  // set center position the map on the screen. 
  useEffect(() => {
    if (!controls || !camera || !groupRef.current) return;

    // Floor change par camera reposition karna
    if (g.selectShapData?.z !== g.CurrentFloor) {

      const floor = g.CurrentFloor;
      const savedAll = JSON.parse(localStorage.getItem("floorCameraData") || "{}");

      if (savedAll[floor]) {
        const isMobileScreen = window.innerWidth < 768;
        const deviceType = isMobileScreen ? 'mobile' : 'pc';

        const saved = savedAll[floor][deviceType];

        if (saved) {
          camera.position.set(saved.camera.x, saved.camera.y, saved.camera.z);
          camera.zoom = saved.camera.zoom;
          camera.updateProjectionMatrix();

          controls.target.set(saved.controls.x, saved.controls.y, saved.controls.z);
          controls.update();

          
        groupRef.current.visible = true;

          return
        }

      }

      

      const box = new THREE.Box3().setFromObject(groupRef.current);
      let center = box.getCenter(new THREE.Vector3());

      // optional: visible
      groupRef.current.visible = true;

      
      // ✅ GSAP animation call
      const distance = getResponsiveDistance(box, camera.fov);
      const tiltAngle = THREE.MathUtils.degToRad(sceneTiltDeg);

      let finalPos = new THREE.Vector3(
        center.x,
        center.y + Math.cos(tiltAngle) * distance,
        center.z + Math.sin(tiltAngle) * distance
      );




      gsap.to(camera.position, {
        duration: 0.6,
        x: finalPos.x,
        y: finalPos.y,
        z: finalPos.z,
        onUpdate: () => invalidate(),
      });

      gsap.to(controls.target, {
        duration: 0.6,
        x: center.x,
        y: center.y,
        z: center.z,
        onUpdate: () => controls.update(),
        onComplete: () => {
          // store default position for reset
          g.setDefaultPosition(center);
        },
      });
    } else {
      if (g.selectShapData) {
        groupRef.current.visible = true;
      }
    }
  }, [g.CurrentFloor, g.selectShapData]);




  const getResponsiveDistance = (
    boundingBox,
    fov,
    coverFactor = 0.9 // 1 = full cover, <1 = thoda kam zoom
  ) => {
    const size = boundingBox.getSize(new THREE.Vector3());
    const width = size.x;
    const height = size.z; // top view
    const aspect = window.innerWidth / window.innerHeight;

    const fovRad = fov * (Math.PI / 180);
    const fitHeight = (height / 2) / Math.tan(fovRad / 2);
    const fitWidth = (width / 2) / (Math.tan(fovRad / 2) * aspect);

    const cover = Math.min(fitHeight, fitWidth);

    // ✅ less zoom (thoda door le aayenge)
    return cover / coverFactor;
  };


  // useEffect(() => {
  //   if (g.selectShapData && g.selectShapData.z === g.CurrentFloor && !g.path.length) {

  //     let multipleObj = groupRef.current.children.filter((mesh) => mesh.point?.LocationName?.text === g.selectShapData?.point?.LocationName?.text)

  //     let pinPosition = []
  //     if (multipleObj.length > 1) {
  //       const group = new THREE.Group();
  //         [...multipleObj].forEach(obj=>{

  //           let newBox = new THREE.Box3().setFromObject(obj)
  //           const vector = new THREE.Vector3();
  //           let xyz = newBox.getCenter(vector)
  //           pinPosition.push(xyz)
  //           group.add( obj.clone());
  //         })

  //         // scene.add(group)
  //         let newBox = new THREE.Box3().setFromObject(group)
  //         const vector = new THREE.Vector3();
  //         const vector1 =  new THREE.Vector3();
  //           let xyz = newBox.getCenter(vector)
  //           let scale = newBox.getSize(vector1)
  //           xyz.scale = window.innerWidth>window.innerHeight? scale.x > 163 ? 80 : 60 : (scale.x > scale.z ? scale.x+(scale.x*50/100) : scale.z+(scale.z*80/100)) 
  //           gsap.to(controls.target, {
  //             x: xyz.x, z: xyz.z, duration: 1, onComplete: () => { }
  //           })
  //           gsap.to(camera.position, {
  //             x: xyz.x, y: xyz.scale, z: xyz.z, duration: 1, onComplete: () => { }
  //           })
  //       // g.setShapZooomPosition(xyz)
  //     }else{
  //       let newBox = new THREE.Box3().setFromObject(multipleObj[0]);
  //       const vector = new THREE.Vector3();
  //       const vector1 =  new THREE.Vector3();
  //       let xyz = newBox.getCenter(vector);
  //       let scale = newBox.getSize(vector1)
  //       pinPosition.push(xyz)
  //       xyz.scale = window.innerWidth>window.innerHeight ? 40 : (scale.x > scale.z ? scale.x+(scale.x*40/100) : 40) 
  //       gsap.to(controls.target, {
  //         x: xyz.x,
  //         z: xyz.z,
  //         duration: 1,
  //       });

  //       gsap.to(camera.position, {
  //         x: xyz.x,
  //         y: xyz.scale,
  //         z: xyz.z,
  //         duration: 1,
  //       });

  //     }
  //     g.setpinArray(pinPosition)
  //   }else{
  //     // alert("Enter")
  //   }
  // }, [g.selectShapData,g.CurrentFloor])


  useEffect(() => {
    if (!g.selectShapData || g.selectShapData.z !== g.CurrentFloor || g.path.length) return;

    let multipleObj = groupRef.current.children.filter(
      (mesh) => mesh.point?.LocationName?.text === g.selectShapData?.point?.LocationName?.text
    );

    let pinPosition = [];

    if (multipleObj.length > 1) {
      // ✅ group banake zoom karna
      const group = new THREE.Group();
      multipleObj.forEach((obj) => {
        const box = new THREE.Box3().setFromObject(obj);
        const center = box.getCenter(new THREE.Vector3());
        pinPosition.push(center);
        group.add(obj.clone());
      });

      // zoomToStore helper ko call
      g.setpinArray(pinPosition);
      zoomToStore(group, { addExtraDistance: 20 })

    } else if (multipleObj.length === 1) {
      // ✅ single mesh zoom
      const obj = multipleObj[0];
      const box = new THREE.Box3().setFromObject(obj);
      const center = box.getCenter(new THREE.Vector3());
      pinPosition.push(center);

      g.setpinArray(pinPosition);
      zoomToStore(obj, { addExtraDistance: 10 })
    }
  }, [g.selectShapData, g.CurrentFloor, g.path]);


  const zoomToStore = (mesh, { distance = defaultZoomDistance, addExtraDistance = 0 } = {}) => {

    return new Promise((resolve) => {


      if (!camera || !controls) return resolve();;
      const padding = 1.2
      const box = new THREE.Box3().setFromObject(mesh);
      const center = box.getCenter(new THREE.Vector3());
      const size = box.getSize(new THREE.Vector3());

      const width = size.x * padding;
      const height = size.z * padding;
      const aspect = camera.aspect;
      const vFOV = THREE.MathUtils.degToRad(camera.fov);


      // 🧠 Calculate distances required to fully fit object
      const fitHeightDistance = height / (2 * Math.tan(vFOV / 2));
      const hFOV = 2 * Math.atan(Math.tan(vFOV / 2) * aspect);
      const fitWidthDistance = width / (2 * Math.tan(hFOV / 2));
      const requiredDistance = Math.max(fitHeightDistance, fitWidthDistance);



      // 🎯 Final distance logic
      let finalDistance;

      finalDistance = distance;
      if (finalDistance < requiredDistance) {
        finalDistance = (requiredDistance + addExtraDistance) + (requiredDistance - finalDistance);
      }


      // 📸 Top-down positioning
      // 👇 Tilted direction instead of straight top-down
      const tiltAngle = THREE.MathUtils.degToRad(sceneTiltDeg); // 30° tilt angle
      const direction = new THREE.Vector3(0, Math.cos(tiltAngle), Math.sin(tiltAngle)).normalize();
      // const direction = new THREE.Vector3(0, 1, 0);

      const newPosition = center.clone().addScaledVector(direction, finalDistance);


      // ✨ Animate camera & controls
      gsap.to(camera.position, {
        duration: 0.8,
        x: newPosition.x,
        y: newPosition.y,
        z: newPosition.z,
      });
      gsap.to(controls.target, {
        duration: 0.8,
        x: center.x,
        y: center.y,
        z: center.z,
        onUpdate: () => {
          controls.update()
        },
        onComplete: resolve
      });
    })


  }


  return (
    <>
      <group ref={groupRef} visible={false}>
        {g.nodePoint && Object.values(g.nodePoint).map((d, i) => {
          if (d.z === g.CurrentFloor) {
            return (
              <ShapBox d={d} index={i} />
            )
          }
        })}

        {g.pinArray.length && g.selectShapData?.z === g.CurrentFloor &&
          g.pinArray.map((pin, index) => {
            return (
              <sprite key={index} position={[pin.x, 4, pin.z]} scale={3} visible={true} >
                {texture &&
                  // sizeAttenuation={false}
                  <spriteMaterial attach="material" map={texture} sizeAttenuation={true} />
                }
              </sprite>
            )
          })
        }
      </group>
    </>
  )
}

export default LoadMap